export default __webpack_public_path__ + "static/media/pantry1-afterF-1024w.414b7677.avif";